const routes = {
  root: '/education/details',
}

export default routes
